import AltTitle from "../components/ui/AltTitle";
import StrokeTitle from "../components/ui/StrokeTitle";
import { useState } from "react";
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Modal from "../components/ui/Modal";
import FlowerTitle from "../components/ui/FlowerTitle";

const Plus = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    size: 6
  })

  const [dlcModal, setDLCModal] = useState({
    visible: false,
    current: 0,
    size: 1
  })

    const [endModal, setEndModal] = useState({
    visible: false,
    current: 0,
    size: 6
  })

  const location = useLocation();
  
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the # character
      const id = location.hash.substring(1);
      
      // Find the element
      const element = document.getElementById(id);
      
      // If the element exists, scroll to it
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // No hash - scroll to top when navigating to this page
      window.scrollTo(0, 0);
    }
  }, [location.hash]);



  return (
    <div className="page-container">
      
    <FlowerTitle text="Quoi de neuf"/>
      <Modal modal={modal} setModal={setModal} url="additional_content_ss_0.jpg"/>
      <Modal modal={dlcModal} setModal={setDLCModal} url="dlc-comp.png"/>
      <Modal modal={endModal} setModal={setEndModal} url="end_content_ss_0.jpg"/>
      <AltTitle text="Disgaea 7 Complete regorge de contenu, dont la version originale de Disgaea 7: Vows of the Virtueless, la totalité des DLC sortis auparavant, ainsi que des nouveautés niveau histoires, personnages, entre autres !" specialClass="plus-top"/>
      <div className="title-accent accent-left">
        <h5 className="black-yellow-text fade-in">Particularité nº 1 de Complete !</h5>
        <StrokeTitle text="Des histoires et des personnages inedits"/>
      </div>
      <h1 className="black-yellow-text" style={{fontSize: '1.75em', textAlign: 'center', marginBottom: '25px', maxWidth: '95vw'}}>
        Des personnages emblématiques se joignent à l'équipe des Démons sans Frontières !
       </h1>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Fuji et ses amis de Disgaea 7: Vows of the Virtueless se rendent dans des Sous-Mondes de jeux précédents ?! <br/> Suite à l'histoire principale, le groupe décide d'aller sauver les âmes toujours coincées dans les Reliques infernales, laissant derrière eux non seulement Edow, mais aussi le monde de Disgaea 7: Vows of the Virtueless dans sa globalité !

        </p>
      </div>
      <h3 className="black-yellow-text header-text"
        style={{
            fontSize: '2em',
            maxWidth: '850px',
            width: '95vw',
            padding: '25px 0px',
            textAlign: 'center'
        }}
      >
        Asagi rejoint le combat !
      </h3>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_05.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 5,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_06.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 6,
            }
          )
        }}/>
      </div>

      <div className="text-wrapper" style={{marginBottom: '0px'}}>
        <p className="white-text">
            Terminez l'histoire de l'équipe des Démons sans Frontières pour obtenir un nouveau personnage : <span style={{color: '#f2cc21'}}> Asagi !</span>
        </p>
      </div>

      <div className="text-wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: "row",
          flexWrap: 'wrap'
        }}
      >
        <p className="white-text"
          style={{
            maxWidth: '600px'
          }}
        >
            Vous vous demandez sûrement qui est Asagi... <br/>
            Vous l'avez peut-être déjà aperçue à plusieurs reprises dans la série Disgaea ou dans d'autres jeux de <br/> Nippon Ichi Software, Inc.<br/>
            <span style={{color: '#f2cc21'}}>
                 Elle s'autoproclame prochain personnage principal externe.
            </span>
        </p>
        <img 
          style={{
            maxWidth: '200px',
            width: '90vw',
            filter: 'drop-shadow(0px 0px 10px white)'
          }}
        src={`${process.env.PUBLIC_URL}/img/plus/asagi.png`} alt="Asagi" />
      </div>
      <div id="dlc" className="title-accent accent-left" style={{paddingTop: '15px'}}>
        <h5 className="black-yellow-text fade-in"
        >Particularité nº 2 de Complete !</h5>
        <StrokeTitle text="Tous les DLC et contenus bonus precedents"/>
      </div>
        <img 
            style={{maxWidth: '850px'}}
        className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/dlc-comp-fr.png`} alt="Includes all DLC characters and scenarios previously released for Disgaea 7: Vows of the Virtueless!" 
        onClick={()=>{
            setDLCModal(
            {
                ...dlcModal,
                'visible': true,
                'current': 1,
            }
            )
        }}/>
      <div className="text-wrapper">
        <p className="white-text">
          Et quand on dit « tous », nous parlons de 7 histoires bonus, 22 nouveaux personnages, des costumes bonus exclusifs, ainsi que des costumes spéciaux ! Rien que ça !
        </p>
      </div>

      <div className="content-wrapper">
          <h3 className="black-yellow-text"
            style={{
              filter: 'drop-shadow(0px 0px 4px black)'
            }}
          >Contenu inclus :</h3>
          <ul className="black-white-text">
            <li>・Histoires bonus (21 personnages supplémentaires)</li>
            
            <li>・Personnage bonus : Pleinair</li>
            
            <li>・Personnages version lunettes</li>
            
            <li>・Ensemble d'armes spéciales</li>
            
            <li>・Set de costumes de la série</li>
            
            <li>・14 costumes d'unités standards supplémentaires</li>
          </ul>
      </div>
      <div className="title-accent accent-left" style={{paddingTop: '25px'}}>
        <h5 className="black-yellow-text fade-in"
        >Particularité nº 3 de Complete !</h5>
        <StrokeTitle text="Encore plus de belles choses !"/>
      </div>
      <div className="text-wrapper">
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
          <span style={{color: '#f2cc21'}}>Mode Infernal</span><br/>
          Nous avons pris en compte votre opinion et avons ajouté plus de flexibilité pour faire passer vos personnages au niveau supérieur...<br/> 
          Euh oui, le mode Infernal est désormais disponible !
        </p>
      </div>
        <div className="pair" style={{
          alignItems: "flex-start"
        }}>
          <div className="item">
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Faites passer des revendications au Conseil infernal pour autoriser l'utilisation du mode Infernal pour tous les personnages.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 2,
                } 
              )
            }}/>
            <h3 className="item-text white-text">
             Équipez la lance démoniaque Banji Tadakatsu, et bénéficiez de trois actions en un même tour en mode Infernal. De quoi rendre même un simple Prinny redoutable !
          </h3>
          </div>
        </div>
        <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Conditions de déverrouillage :</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
            Faire passer la revendication pour l'utilisation libre de Reliques infernales après avoir terminé l'histoire principale.
          </p>
        </div>
        <div className="text-wrapper" style={{marginBottom: '50px'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
        <span style={{color: '#f2cc21'}}>Des stats encore plus élevées</span><br/>
          Allez au-delà des limites auparavant fixées et créez votre personnage ultime avec des statistiques pouvant atteindre de nouveaux sommets !
        </p>
      </div>
              <div className="pair" style={{
          alignItems: "flex-start"
        }}>
          <div className="item">
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Faire monter vos personnages favoris de niveau à votre guise fait partie de la base de la série Disgaea.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 4,
                } 
              )
            }}/>
            <h3 className="item-text white-text">
              Avec ces possibilités infinies, même un modeste Prinny pourrait faire de lourds dégâts !
            </h3>
          </div>
        </div>
                <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Conditions de déverrouillage :</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
           Faire passer la revendication permettant d'aller au-delà des limites après avoir terminé Baal du Carnage.
          </p>
        </div>
        <div className="text-wrapper" style={{marginBottom: '50px'}}>
          <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
            <span style={{color: '#f2cc21'}}>Le boss ultime, Rakshasa Baal </span><br/>
            <span style={{color: '#f2cc21'}}>Rakshasa Baal</span>  fait son apparition depuis une autre dimension, se vantant d'être encore plus redoutable que le minable Baal du Carnage ! Utilise ton équipe aguerrie pour affronter et terrasser le mal ultime ! 
          </p>
        </div>
              <div className="pair" style={{
          alignItems: "flex-start"
        }}>
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_05.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_06.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 6,
                } 
              )
            }}/>
        </div>
          <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Conditions de déverrouillage :</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
            Faire passer la revendication pour permettre de se battre contre un Super Overlord de niveau supérieur après avoir terminé Baal du Carnage.
          </p>
        </div>
    </div>

  )
}

export default Plus;